<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    title="Private Key"
    :ok-only="true"
    :visible="modal.privateKey"
    @show="resetModal"
    :hide-footer="false"
    :hide-header-close="true"
    :no-close-on-esc="true"
    @hidden="resetModal"
    :no-close-on-backdrop="true ? true : false"
    size="lg"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="mb-3">
        <b-col lg="6"
          ><b-form-file
            v-model="utc"
            :state="Boolean(utc)"
            placeholder="Choose UTC File..."
            drop-placeholder="Drop file here..."
            @change="previewContent"
            class="mb-3"
          ></b-form-file>
        </b-col>
        <b-col lg="3">
          <b-form-input
            id="private-key"
            v-model="utc_passphrase"
            :state="utc_passphraseState"
            placeholder="Passphrase"
            type="password"
            required
          ></b-form-input>
        </b-col>
        <b-col lg="3">
          <b-button type="button" variant="primary" block @click="submit_utc"
            >Confirm</b-button
          >
        </b-col>
      </b-row>
      <b-row class="mb-3"
        ><b-col lg="6">
          <b-form-group :state="privateKeyState">
            <b-form-input
              id="private-key"
              v-model="mnemonic"
              :state="mnemonicState"
              placeholder="Enter Mnemonic"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-input
            id="private-key"
            v-model="mnemonic_passphrase"
            :state="mnemonic_passphraseState"
            placeholder="Passphrase"
            type="password"
            required
          ></b-form-input>
        </b-col>
        <b-col lg="3">
          <b-button
            type="button"
            variant="primary"
            block
            @click="submit_mnemonic"
            >Confirm</b-button
          >
        </b-col>
      </b-row>
      <b-row
        ><b-col lg="6">
          <b-form-group :state="privateKeyState">
            <b-form-input
              id="private-key"
              v-model="privateKey"
              :state="privateKeyState"
              placeholder="Enter Raw Private Key"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-input
            id="private-key"
            v-model="raw_passphrase"
            :state="raw_passphraseState"
            placeholder="Passphrase"
            type="password"
            required
          ></b-form-input>
        </b-col>
        <b-col lg="3">
          <b-button type="button" variant="primary" block @click="submit_raw"
            >Confirm</b-button
          >
        </b-col>
      </b-row>
    </form>

    <template v-slot:modal-footer>
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button
        size="md"
        block
        variant="secondary"
        @click="close_private_key_modal"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getUtc } from '@/utils/getUtc'
import { getPrivKey } from '@/utils/getPrivKey'
import store from '@/store'
import CryptoJS from 'crypto-js'
import Wallet from 'ethereumjs-wallet'
import { toBuffer } from 'ethereumjs-util'

export default {
  data() {
    return {
      privateKey: '',
      utc_passphrase: '',
      mnemonic_passphrase: '',
      raw_passphrase: '',
      mnemonic: '',
      utc_content: '',
      privateKeyState: null,
      utc_passphraseState: null,
      mnemonic_passphraseState: null,
      raw_passphraseState: null,
      mnemonicState: null,
      utc: null
    }
  },
  methods: {
    ...mapActions(['init_notification']),
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.privateKeyState = valid
      return valid
    },
    resetModal() {
      this.privateKey = ''
      this.privateKeyState = null
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    previewContent: function(e) {
      let reader = new FileReader()
      reader.readAsText(e.target.files[0], 'UTF-8')
      reader.onload = evt => {
        this.utc_content = evt.target.result
      }
      reader.onerror = evt => {
        console.log('Error : ', evt)
      }
    },
    submit_utc: async function() {
      const { utc, utc_content, session, utc_passphrase } = this
      if (!utc) return

      const utc_instance = await getUtc(utc_content, utc_passphrase)

      let encrypted = CryptoJS.AES.encrypt(
        `0x${utc_instance.PrivateKey}`,
        utc_passphrase
      )

      session(encrypted, `0x${utc_instance.Address}`)
    },
    submit_mnemonic: async function() {
      const { mnemonic, session, mnemonic_passphrase } = this

      if (!mnemonic) return

      let mnemonic_instance = await getPrivKey(mnemonic)

      let encrypted = CryptoJS.AES.encrypt(
        mnemonic_instance.PrivateKey,
        mnemonic_passphrase
      )

      session(encrypted, mnemonic_instance.Address)
    },
    submit_raw: function() {
      const { privateKey, raw_passphrase, session } = this
      if (!privateKey) return

      const wallet = Wallet.fromPrivateKey(toBuffer(`0x${privateKey}`))

      let encrypted = CryptoJS.AES.encrypt(
        `0x${wallet.getPrivateKey().toString('hex')}`,
        raw_passphrase
      )

      session(encrypted, `0x${wallet.getAddress().toString('hex')}`)
    },
    session: function(private_key, address) {
      if (!private_key) return

      sessionStorage.setItem('private_key', private_key)
      sessionStorage.setItem('address', address)

      store.commit('load_account', address)

      store.commit('load_modal', { privateKey: false })

      this.init_notification({
        isVisible: true,
        header: 'Welcome',
        body: `User successfully logged in.`
      })
    },
    close_private_key_modal: function() {
      store.commit('load_modal', { privateKey: false })
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState(['modal'])
  },
  mounted() {}
}
</script>

<style>
* {
}
</style>
